import React from 'react'
import './Tabs.css'

class Tabs extends React.Component {
  scrollRef = React.createRef()
  state = {
    showLeftGradient: false
  }

  handleWheel = e => {
    const { showLeftGradient } = this.state
    const { scrollLeft } = this.scrollRef.current
    this.scrollRef.current.scrollLeft = scrollLeft + e.deltaY

    if (!showLeftGradient && this.scrollRef.current.scrollLeft > 0) {
      this.setState({ showLeftGradient: true })
    } else if (showLeftGradient && this.scrollRef.current.scrollLeft <= 0) {
      this.setState({ showLeftGradient: false })
    }
  }

  render() {
    const { showLeftGradient } = this.state
    return (
      <div className="cookunity__tabs" onWheel={this.handleWheel}>
        {showLeftGradient && <div className="gradient-left" />}
        <div className="hide-scroll">
          <ul className="hide-scroll-child hs full" ref={this.scrollRef}>
            {this.props.children}
          </ul>
        </div>
        <div className="gradient-right" />
      </div>
    )
  }
}

export default Tabs



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.jsx